// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_11d","cls2":"ExportFormatModal-cls2_9d2 ExportFormatModal-cls1_11d"};